import { Backdrop, Box, CircularProgress, SxProps, Theme } from "@mui/material";
import React, { ReactNode } from "react";

export type LoadingZoneProps = {
    isLoading: boolean;
    children?: ReactNode;
    sx?: SxProps<Theme>
};

export default function LoadingZone({ isLoading, children, sx }: LoadingZoneProps) {
    return (
        <Box sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflow: "hidden",
            ...sx
        }}>
            {isLoading &&
                <Backdrop sx={{
                    zIndex: theme => theme.zIndex.drawer,// + 1,
                    color: '#fff',
                    position: 'absolute'
                }} open={true}>
                    <CircularProgress />
                </Backdrop>
            }
            {children}
        </Box>
    );
}
